import Data from "../Data";
import StyleItem from "../StyleItem";
import "../Taketour.css";
import heroExpenses from "../../../../assets/images/hero-expenses.png"

const Expense = ({ }) => {

    const { expensesData } = Data();
    return (
        <div>
            {expensesData.map((item, index) => (
                <StyleItem key={index} data={item} />
            ))}
            <div className="taketour-image-section">
                <img src={heroExpenses} alt="" />
            </div>
        </div>
    );
};

export default Expense;
